import { Vue, Watch, Prop, Component } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class BottomButton extends Vue {
  @Prop({ default: () => {} })
    value: MiniPageButtonInfo;
  @Prop({ default: 0 })
    fromPage: number;
  @Prop({ default: true })
    isDisplay: Boolean

  render(h) {
    return (
      <div class="inline-block absolute border-bottom-white" style={`width: calc(100% - ${(this.$parent as ItemObject).getPaddingRight}px);left: 1px;bottom:${this.isDisplay?this.fromPage===3?'180px':'136px':'0'}`}>
        <div class="mini-button" style={`background: ${this.value.buttonVal}; color: ${this.value.textColor};`}>
          {this.value.content}
        </div>
      </div>
    );
  }
}
